module.exports = __webpack_public_path__ + "img/api-community.7b0d2db1.svg";